import React from 'react'
import LogoImg from '../../assets/images/logo.png'

const Logo = () => {
    return <img src={LogoImg} width={120} alt="" />
}

export default Logo
